import { defineComponent as _defineComponent } from 'vue'
import { Banner } from '@/components/banners/bannerStore'
import { useAppInsights } from '@/common/useAppInsights'


export default /*#__PURE__*/_defineComponent({
  __name: 'banner',
  props: {
    content: null
  },
  setup(__props: any) {



const appInsights = useAppInsights()

const actionClicked = () => {
  appInsights?.trackEvent({ name: 'June13BannerSignUp' })

  const signUpLink =
    'https://zoom.us/webinar/register/WN_koXSbFpxQH6fVeceRNfmnw?utm_campaign=June%2013th%20Event&utm_source=app&utm_medium=banner&utm_content=june-13-2024'
  window.open(signUpLink, '_blank', 'noreferrer')
}

return { __sfc: true,appInsights, actionClicked }
}

})